import { FC } from 'react';
import { Skeleton as SkeletonUI } from '@mofid-securities/uikit';

export const Skeleton: FC = () => {
  return (
    <div className="mt-7">
      <SkeletonUI className="!mb-3" height={14} width={'100%'} />
      <SkeletonUI className="!mb-3" height={14} width={'100%'} />
      <SkeletonUI height={14} width={'70%'} />
    </div>
  );
};
